import QuickStartDocsFeature from '../../features/docs/quick-start-feature';

export default function QuickStartDocsPage() {
  return <QuickStartDocsFeature />;
}
